const LeaveAdjustmentTypes = {
	// TYPES FOR GET EMPLOYEE LEAVE BALANCE
	GET_EMPLOYEE_LEAVE_BALANCE_START: 'get_employee_leave_balance_start',
	GET_EMPLOYEE_LEAVE_BALANCE_SUCCESS: 'get_employee_leave_balance_success',
	GET_EMPLOYEE_LEAVE_BALANCE_FAILURE: 'get_employee_leave_balance_failure',
	GET_EMPLOYEE_LEAVE_BALANCE_KEY: 'GetEmployeeLeaveBalanceFromWeb',

	// TYPES FOR CREATE LEAVE ADJUSTMENT
	CREATE_LEAVE_ADJUSTMENT_START: 'create_leave_adjustment_start',
	CREATE_LEAVE_ADJUSTMENT_SUCCESS: 'create_leave_adjustment_success',
	CREATE_LEAVE_ADJUSTMENT_FAILURE: 'create_leave_adjustment_failure',
	CREATE_LEAVE_ADJUSTMENT_RESPONSE_RESET: 'create_leave_adjustment_response_reset',
	CREATE_LEAVE_ADJUSTMENT_KEY: 'CreateLeaveAdjustmentFromWeb',
};

export default LeaveAdjustmentTypes;

